module.exports = __webpack_public_path__ + "static/media/huawei_battery_3.05d52bca.png";